import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/layouts/dashboard';
import AuthGuard from 'src/auth/AuthGuard';
import RoleBasedGuard from 'src/auth/RoleBasedGuard';
import { PATH_AFTER_LOGIN } from 'src/config-global';
import { ROLES } from 'src/constants/roles';
import {
  GeneralApp,
  CheckPriceMonitor,
  UserAccounts,
  Storages,
  Product,
  ProductCategory,
  ProductBrand,
  Users,
  StorageDocuments,
  StorageShipments,
  I18nLang,
  I18nKeys,
  Accounts,
  TransactionArticles,
  SourceOrders,
  OzonSellerAccounts,
  Transactions,
  Sales,
  OzonPostings,
  WbSellerAccounts,
  WbPostings,
  WbCatalogProducts,
  AvitoSellerAccounts,
  AvitoPostings,
  DeliveryServices,
  DocumentTemplates,
  Sites,
  SiteShop,
  SiteShopCategories,
  SiteShopProducts,
  SiteShopPayments,
  SiteShopDeliveries,
  SiteNews,
  SitePages,
  Groups,
  ProcurementSuppliers,
  ProcurementRequests,
  ProcurementContracts,
  ProcurementDeliveries,
} from '../elements';

export const dashboardRoute: RouteObject = {
  path: 'dashboard',
  element: (
    <AuthGuard>
      <DashboardLayout />
    </AuthGuard>
  ),
  children: [
    { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
    { path: 'app', element: <GeneralApp /> },
    { path: 'checkPrice/*', element: <CheckPriceMonitor /> },
    {
      path: 'user',
      children: [
        { element: <Navigate to="/dashboard/user/account" replace />, index: true },
        { path: 'account', element: <UserAccounts /> },
      ],
    },
    {
      path: 'dictionaries',
      children: [
        {
          element: <Navigate to="/dashboard/dictionaries/product" replace />,
          index: true,
        },
        { path: 'product/*', element: <Product /> },
        { path: 'category/*', element: <ProductCategory /> },
        { path: 'brand/*', element: <ProductBrand /> },
        { path: 'storages/*', element: <Storages /> },
        { path: 'accounts/*', element: <Accounts /> },
        { path: 'transaction-articles/*', element: <TransactionArticles /> },
        { path: 'source-orders/*', element: <SourceOrders /> },
        { path: 'delivery-services/*', element: <DeliveryServices /> },
        { path: 'document-templates/*', element: <DocumentTemplates /> },
      ],
    },
    {
      path: 'administration',
      children: [
        {
          element: <Navigate to="/dashboard/administration/user" replace />,
          index: true,
        },
        {
          path: 'i18nLang/*',
          element: (
            <RoleBasedGuard hasContent roles={[ROLES.ADMIN]}>
              <I18nLang />
            </RoleBasedGuard>
          ),
        },
        {
          path: 'translations/*',
          element: (
            <RoleBasedGuard hasContent roles={[ROLES.ADMIN]}>
              <I18nKeys />
            </RoleBasedGuard>
          ),
        },
        {
          path: 'user/*',
          element: (
            <RoleBasedGuard hasContent roles={[ROLES.ADMIN]}>
              <Users />
            </RoleBasedGuard>
          ),
        },
        {
          path: 'groups/*',
          element: (
            <RoleBasedGuard hasContent roles={[ROLES.ADMIN]}>
              <Groups />
            </RoleBasedGuard>
          ),
        },
      ],
    },
    { path: 'storageDocuments/*', element: <StorageDocuments /> },
    { path: 'storageShipments/*', element: <StorageShipments /> },
    { path: 'sales/*', element: <Sales /> },
    { path: 'ozon/seller-accounts/*', element: <OzonSellerAccounts /> },
    { path: 'ozon/postings/*', element: <OzonPostings /> },
    { path: 'wb/seller-accounts/*', element: <WbSellerAccounts /> },
    { path: 'wb/postings/*', element: <WbPostings /> },
    { path: 'wb/catalog-products/*', element: <WbCatalogProducts /> },
    { path: 'avito/seller-accounts/*', element: <AvitoSellerAccounts /> },
    { path: 'avito/postings/*', element: <AvitoPostings /> },
    { path: 'transactions/*', element: <Transactions /> },
    { path: 'sites/*', element: <Sites /> },
    { path: 'sites/:id/shop', element: <SiteShop /> },
    { path: 'sites/:id/shop/categories/*', element: <SiteShopCategories /> },
    { path: 'sites/:id/shop/products/*', element: <SiteShopProducts /> },
    { path: 'sites/:id/shop/payment/*', element: <SiteShopPayments /> },
    { path: 'sites/:id/shop/delivery/*', element: <SiteShopDeliveries /> },
    { path: 'sites/:id/news/*', element: <SiteNews /> },
    { path: 'sites/:id/pages/*', element: <SitePages /> },
    { path: 'procurement/suppliers/*', element: <ProcurementSuppliers /> },
    { path: 'procurement/contracts/*', element: <ProcurementContracts /> },
    { path: 'procurement/requests/*', element: <ProcurementRequests /> },
    { path: 'procurement/deliveries/*', element: <ProcurementDeliveries /> },
  ],
};
